export const adaptStorePayload = (
	formValues: StoreFormValues
): { name: string; region: number | null; area: number | null } => {
	return {
		name: formValues.name,
		region: formValues.region ? Number(formValues.region) : null,
		area: formValues.area ? Number(formValues.area) : null
	};
};
